import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import "highcharts/modules/vector";

export default function ({data, id}) {
    function renderEmpty() {
        if (data.length <= 0) {
            return 'No data';
        }

        return null;
    }

    return (
        <div>
            {renderEmpty()}
            <div id={"skill-vector-graph-" + id}/>
            <HighchartsReact
                highcharts={Highcharts}
                options={{
                    title: {
                        text: undefined
                    },
                    xAxis: {
                        gridLineWidth: 1,
                        min: 0,
                        max: 50,
                        labels: {
                            enabled: false
                        }
                    },
                    yAxis: {
                        title: {
                            text: undefined
                        },
                        labels: {
                            enabled: false
                        },
                        min: -50,
                        max: 50
                    },
                    plotOptions: {
                        vector: {
                            vectorLength: 130,
                            rotationOrigin: 'start'
                        }
                    },
                    tooltip: {
                        enabled: false
                    },
                    credits: {
                        enabled: false
                    },
                    series: data.map(item => {
                        return {
                            type: 'vector',
                            name: item.name,
                            data: [
                                [0, 0, 50, 270 - item.angle]
                            ]
                        }
                    })
                }}
            />
        </div>
    );
}
